import Vue from "vue";
import "./plugins/vuetify";
import "./global/global.less";
import App from "./App.vue";
import router from "./router/";
import store from "./store";
import "./registerServiceWorker";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "font-awesome/css/font-awesome.css";
import Axios from "axios";
import Vuetify from "vuetify";

Vue.use(Vuetify);
Vue.config.productionTip = false;

Vue.prototype.$http = Axios.create({
  baseURL: "http://api-sistema.l6s.com.br/api/",
});

Vue.prototype.$http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

Vue.prototype.$http.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (401 === error.response.status) {
      window.location = "/login";
      return;
    }
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
